export default [
  {
    path: '/attending',
    name: 'attending',
    component: () => import('@/views/attending/attendingQueue/index.vue'),
  },
]
